

// export default DeletedCashiersList;
import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  CircularProgress,
  List,
  ListItem,
  ListItemText,
  IconButton,
  Alert,
  Typography,
  Tooltip,
  Snackbar,
} from "@mui/material";
import RestoreIcon from "@mui/icons-material/RestoreFromTrash";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { fetchCashiersByBranch, toggleCashierStatus } from "../../../../../services/Settings/Cashier";

const DeletedCashiersList = ({ open, onClose, branchId, onRestored }) => {
  const [loading, setLoading] = useState(false);
  const [cashiers, setCashiers] = useState([]);
  const [error, setError] = useState(null);
  const [message, setMessage] = useState("");

  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [selectedCashier, setSelectedCashier] = useState(null);

  useEffect(() => {
    if (open && branchId) loadDeletedCashiers();
  }, [open, branchId]);

  const loadDeletedCashiers = async () => {
    setLoading(true);
    try {
      const data = await fetchCashiersByBranch(branchId);
      const deleted = data.filter((cashier) => cashier.status === 0);
      setCashiers(deleted);
      setError(null);
    } catch (err) {
      setError("❌ فشل في تحميل الكاشيرات المحذوفة.");
    } finally {
      setLoading(false);
    }
  };

  const confirmRestore = (cashier) => {
    setSelectedCashier(cashier);
    setConfirmDialogOpen(true);
  };

  const handleRestore = async () => {
    if (!selectedCashier) return;
    try {
      const res = await toggleCashierStatus(selectedCashier.id);
      setMessage(`✅ ${res.message}`);
      loadDeletedCashiers();
      if (onRestored) onRestored(); // ✅ تحديث القائمة الأصلية
    } catch (err) {
      setMessage(err.message || "❌ فشل في استرجاع الكاشير.");
    } finally {
      setConfirmDialogOpen(false);
      setSelectedCashier(null);
    }
  };

  return (
    <>
      <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
        <DialogTitle>🗑️ سلة الكاشيرات المحذوفة</DialogTitle>
        <DialogContent dividers>
          {loading && <CircularProgress />}
          {error && <Alert severity="error">{error}</Alert>}
          {!loading && cashiers.length === 0 && (
            <Typography>لا توجد كاشيرات محذوفة حاليًا.</Typography>
          )}
          <List>
            {cashiers.map((cashier) => (
              <ListItem key={cashier.id} divider>
                <ListItemText
                  primary={`🧾 ${cashier.name}`}
                  secondary={`الفرع: ${cashier.root_name} | الطابعة: ${cashier.printer_name}`}
                />
                <Tooltip title="استرجاع">
                  <IconButton onClick={() => confirmRestore(cashier)}>
                    <RestoreIcon />
                  </IconButton>
                </Tooltip>
              </ListItem>
            ))}
          </List>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="secondary">إغلاق</Button>
        </DialogActions>
      </Dialog>

      {/* ✅ Dialog تأكيد الاسترجاع */}
      <Dialog open={confirmDialogOpen} onClose={() => setConfirmDialogOpen(false)}>
        <DialogTitle>تأكيد الاسترجاع</DialogTitle>
        <DialogContent>
          <Typography>
            هل أنت متأكد أنك تريد استرجاع الكاشير "{selectedCashier?.name}"؟
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmDialogOpen(false)} color="secondary">
            إلغاء
          </Button>
          <Button onClick={handleRestore} color="primary" variant="contained">
            تأكيد
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={!!message}
        autoHideDuration={3000}
        onClose={() => setMessage("")}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert severity={message.startsWith("✅") ? "success" : "error"}>
          {message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default DeletedCashiersList;
